import { ShiftSettingsEffects } from './shift-settings.effects';

export const effects: Array<any> = [ShiftSettingsEffects];

export * from './shift-settings.effects';
